import { Icons, LoadingIndicator } from '@commenda/kakashi';

import { ServiceAuditorStageStatus } from '@commenda/api/agent-platform/service-auditor/types';

interface IServiceAuditRunStageIconProps {
  status: ServiceAuditorStageStatus;
}

export const ServiceAuditRunStageIcon = ({
  status,
}: IServiceAuditRunStageIconProps) => {
  if (status === ServiceAuditorStageStatus.RUNNING) {
    // Kakashi draws the moving arc in a neutral stroke; the running stage is one of the reserved brand accents.
    return (
      <LoadingIndicator
        size={16}
        _className="[&_circle:last-child]:stroke-fg-brand"
      />
    );
  }
  if (status === ServiceAuditorStageStatus.COMPLETED) {
    return <Icons.CheckCircle className="size-4 text-text-success" />;
  }
  if (status === ServiceAuditorStageStatus.FAILED) {
    return <Icons.XCircle className="size-4 text-text-error" />;
  }
  return <Icons.Circle className="size-4 text-text-quaternary" />;
};
